import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';
import { apiURL } from '../config/default';

export const apiSlice = createApi({
  reducerPath: 'sundialApi',
  baseQuery: axiosBaseQuery({ baseUrl: apiURL }), // Uses your API URL logic
  tagTypes: ['Homepage', 'Section', 'Content', 'Row', 'UserDynamic', 'Gallery', 'PriceHistory', 'VendorPricingSchedule'],
  endpoints: () => ({}),
});